import {ModelViews} from './ModelViewsActions';

//Дефаултные значения для представлений
const initialVViewsState = {
    state: "empty",     //Состояние ассета
    iri: null,
    rpc: null,
    ontology: null,
    views: [],          //Список представлений
};
export const vviews = (state = { ...initialVViewsState}, action) => {
    switch (action.type) {
        case "ModelViews.EMPTY":
            return{
                ...initialVViewsState,
            }
        case "ModelViews.LOAD_STARTED":
            return{
                ...state,
                state: "load",
            }
        case "ModelViews.LOAD_ERROR":
            return {
                ...initialVViewsState,
                state: "error",
                error: action.error
            };
        case "ModelViews.LOAD_VIEWS":
            return {
                ...state,
                iri: action.iri,
                ontology: action.views,
                model: action.model,
                views: action.views,
                state: "loaded",
            };
    default:
            return state;
    }
}
